import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import focusDropdownSearch from 'scaleflow/utils/focus-dropdown-search';
import nameSort from 'scaleflow/utils/nameSort';

export default class DropdownsRoadmapComponent extends Component {
  @service store;

  @tracked textFilter = '';

  tippyInstance = null;

  get ComponentName() {
    return this.args?.tippy ? 'Tippy' : 'empty-component';
  }

  get roadmaps() {
    const roadmaps = this.store.peekAll('roadmap');
    return roadmaps.map((item) => ({ label: item.title, value: item.id }));
  }

  get trigger() {
    return this.args?.trigger ?? 'click';
  }

  get placement() {
    return this.args.placement ?? 'top';
  }

  get interactive() {
    return this.args.interactive ?? true;
  }

  get searchable() {
    return this.roadmaps.length > 6;
  }

  @action
  handleClick(item) {
    this.args?.onSelect?.(item);
    this.tippyInstance.hide();
    return;
  }

  get roadmapsList() {
    const roadmaps = this.roadmaps;
    const filteredRoadmaps = !this.textFilter
      ? roadmaps
      : roadmaps.filter(
          (item) =>
            item.label.toLowerCase().indexOf(this.textFilter.toLowerCase()) >=
            0,
        );
    return filteredRoadmaps.sort((a, b) => nameSort(a.label, b.label));
  }

  @action
  handleSearch(text) {
    this.textFilter = text;
  }

  @action
  onShown(instance) {
    focusDropdownSearch(instance);
  }

  @action
  onCreate(e) {
    this.tippyInstance = e;
  }

  @action
  handleAddRoadmap() {
    this.args?.onAddRoadmapClick?.();
  }
}
